import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import userQueries from "../../../requests/queries/userQuesries";
import "./auth.css";

export default function Register() {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
        secret_code: "",
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await userQueries.register(formData.email, formData.password, formData.secret_code);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-logo">✨</div>
                <h1 className="auth-title">Créer un compte</h1>
                <p className="auth-subtitle">
                    Rejoignez-nous et commencez à créer
                </p>

                <form className="auth-form" onSubmit={handleSubmit}>
                    <div className="auth-input-group">
                        <label className="auth-label" htmlFor="email">
                            Adresse email
                        </label>
                        <input
                            id="email"
                            className="auth-input"
                            type="email"
                            name="email"
                            placeholder="vous@exemple.com"
                            value={formData.email}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="auth-input-group">
                        <label className="auth-label" htmlFor="password">
                            Mot de passe
                        </label>
                        <input
                            id="password"
                            className="auth-input"
                            type="password"
                            name="password"
                            placeholder="••••••••"
                            value={formData.password}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="auth-input-group">
                        <label className="auth-label" htmlFor="secret_code">
                            Code secret
                        </label>
                        <input
                            id="secret_code"
                            className="auth-input"
                            type="text"
                            name="secret_code"
                            placeholder="Entrez votre code d'invitation"
                            value={formData.secret_code}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <button 
                        type="submit" 
                        className={`auth-button ${isLoading ? 'loading' : ''}`}
                        disabled={isLoading}
                    >
                        <span>Créer mon compte →</span>
                    </button>
                </form>

                <div className="auth-footer">
                    Déjà un compte ?{" "}
                    <Link to="/login" className="auth-link">
                        Se connecter
                    </Link>
                </div>
            </div>
        </div>
    );
}
